import { withInstall } from '@tw-element/utils'
import Avatar from './src/avatar.vue'

export const TwAvatar = withInstall(Avatar)
export default TwAvatar

export * from './src/avatar'
